import styled, { css } from 'styled-components'
import { Div, P as PKS } from 'konsys-ui'
import { Tabs } from 'antd'
import { theme } from '../../styles/_variables'
import Img from '../../components/common/img'

export const Image = styled(Img)`
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 5px;
  border: 1px ${theme.color.veryLightBlue} solid;
`

export const PartImage = styled(Img)`
  width: 250px;
  height: 250px;
  object-fit: cover;
  border-radius: 5px;
  border: 1px ${theme.color.veryLightBlue} solid;
  margin-right: 48px;
`

export const TabWrapper = styled(Tabs)`

`

export const TabPane = styled(Tabs.TabPane)`

`

export const RadioWrapper = styled(Div)`
  border: 1px solid ${theme.color.lightBlue};
  padding: 16px;
  border-radius: 4px;
  > div {
    &:last-child {
      transition: max-height 0.5s ease-in-out;
      max-height: 0;
      overflow: hidden;
    }
  }
  ${props => props.open && css`
    > div {
      &:last-child {
        max-height: 2000px;
        /* overflow: scroll; */
        margin-top: 24px;
      }
    }
  `}
`
export const P = styled(PKS)`
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`

export default TabWrapper
